import { createSelector } from "reselect";

import * as api from "@/api/permissions";
const prefix = "admin/permissions";

const FETCH_START = `${prefix}/FETCH_START`;
const FETCH_FAIL = `${prefix}/FETCH_FAIL`;
const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;

const fetchStart = (_query) => ({ type: FETCH_START, payload: true });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAIL, error: true, payload: err });

const baseSelector = (state) => state.permission.list;

export const getIsFetching = createSelector(baseSelector, (state) => state.isFetching);

export const getRecords = createSelector(baseSelector, (state) => state.records);

export const hasRecords = createSelector(getRecords, (records) => records.length > 0);

export function fetchRecords(query) {
  return async (dispatch, getState) => {
    if (hasRecords(getState())) {
      return;
    }

    dispatch(fetchStart(query));

    try {
      const data = await api.fetchRecords(query);
      dispatch(fetchSuccess(data));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

const initialState = {
  records: [],
  error: false,
  isFetching: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        // records: [],
        isFetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        records: action.payload.records,
        isFetching: false,
        error: null,
      };

    case FETCH_FAIL:
      return {
        ...state,
        records: [],
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
